import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Layouts

// routes
import { authProtectedRoutes, publicRoutes } from './allRoutes';
import AuthProtected from './AuthProtected';

import Layout from 'components/Layouts/Layout';
import NonAuthLayout from 'components/Layouts/NonAuthLayout';

const renderRoutes = (route: any, idx: any): React.ReactElement => {
  if (!route?.children && route?.children?.length === 0) {
    return (
      <Route
        path={route.path}
        element={
          <AuthProtected>
            <Layout>{route.component}</Layout>
          </AuthProtected>
        }
        key={idx}
      />
    );
  } else {
    return (
      <Route path={route.path} element={route.component} key={idx}>
        {route.children?.map((childrenRoute: any, idc: any) => renderRoutes(childrenRoute, idc))}
      </Route>
    );
  }
};

const Index = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route>
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={<NonAuthLayout>{route.component}</NonAuthLayout>} key={idx} />
          ))}
        </Route>

        <Route>
          {/* {authProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <AuthProtected>
                  <Layout>{route.component}</Layout>
                </AuthProtected>
              }
              key={idx}
            />
          ))} */}

          {authProtectedRoutes.map((route, idx) => renderRoutes(route, idx))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
